'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaginationPanel = exports.DataphiGrid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapTable = require('react-bootstrap-table');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iteration = 0;

var DataphiGrid = exports.DataphiGrid = function (_Component) {
    _inherits(DataphiGrid, _Component);

    function DataphiGrid(props) {
        _classCallCheck(this, DataphiGrid);

        var _this = _possibleConstructorReturn(this, (DataphiGrid.__proto__ || Object.getPrototypeOf(DataphiGrid)).call(this, props));

        _this.getTableFormat = function (cell, row, formatExtraData, rowIdx, col) {
            var keyField = _this.state.keyField;

            ++iteration;
            //if(Boolean(col.phiDataFormat))
            function getCellData(cell, row, column, rowIdx, col) {
                iteration = iteration % 4 === 0 ? 0 : column;
                if (Boolean(col.phiDataFormat)) {
                    var unqIdentifier = 'cell_' + row['' + keyField] + column;
                    return _react2.default.createElement(
                        'div',
                        null,
                        col.phiDataFormat(cell, row, unqIdentifier)
                    );
                } else {
                    return _react2.default.createElement(
                        'div',
                        { id: 'cell_' + row.id + column },
                        cell
                    );
                }
            }
            return getCellData(cell, row, iteration, rowIdx, col);
        };

        _this.state = _extends({}, props);
        return _this;
    }

    _createClass(DataphiGrid, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props !== nextProps) {
                this.setState(_extends({}, nextProps));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactBootstrapTable.BootstrapTable,
                    this.state,
                    this.state.tableHeaderColumn.map(function (col, i) {
                        return _react2.default.createElement(
                            _reactBootstrapTable.TableHeaderColumn,
                            _extends({
                                dataFormat: function dataFormat(cell, row, formatExtraData, rowIds) {
                                    return _this2.getTableFormat(cell, row, formatExtraData, rowIds, col);
                                },
                                key: i
                            }, col),
                            col.value
                        );
                    })
                )
            );
        }
    }]);

    return DataphiGrid;
}(_react.Component);

DataphiGrid.propTypes = {
    data: _propTypes2.default.array.isRequired,
    tableHeaderColumn: _propTypes2.default.array.isRequired,
    keyField: _propTypes2.default.string.isRequired
};

DataphiGrid.defaultProps = {
    data: [],
    tableHeaderColumn: [],
    keyField: ''
    /* 
    class PaginationPanel extends Component
     */
};var PaginationPanel = exports.PaginationPanel = function PaginationPanel(props) {
    var paginationSize = props.paginationSize;
    var currentPage = props.currentPage;
    var iterationFrom = currentPage - Math.floor(paginationSize / 2);
    var iterationUpto = iterationFrom + paginationSize - 1;
    var pages = props.pages,
        goToThisPage = props.goToThisPage;


    function paginationItem() {
        var listItem = [];

        var _loop = function _loop(i) {
            if (i > 0 && i <= pages) {
                listItem.push(_react2.default.createElement(
                    'li',
                    { key: i, className: i === currentPage ? 'active' : null, onClick: function onClick() {
                            return goToThisPage(i);
                        } },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn ' + (i === currentPage ? 'btn-success' : 'btn-light') },
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            i
                        )
                    )
                ));
            }
        };

        for (var i = iterationFrom; i <= iterationUpto; i++) {
            _loop(i);
        }
        return listItem;
    }
    return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
                'span',
                null,
                'Change size per page: '
            ),
            props.props.components.sizePerPageDropdown
        ),
        _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
                'div',
                { style: { float: 'right', marginTop: '-20px' } },
                _react2.default.createElement(
                    'nav',
                    { 'aria-label': 'Page navigation' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'pagination' }, 
                        currentPage > 1 && _react2.default.createElement(
                            'li',
                            { onClick: function onClick() {
                                    return goToThisPage(1);
                                } },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-light', 'aria-label': 'First' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '\xAB'
                                )
                            )
                        ),
                        currentPage > 1 && _react2.default.createElement(
                            'li',
                            { onClick: function onClick() {
                                    return goToThisPage(currentPage - 1);
                                } },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-light', 'aria-label': 'Previous' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '<'
                                )
                            )
                        ),
                        paginationItem(),
                        currentPage !== props.pages && _react2.default.createElement(
                            'li',
                            { onClick: function onClick() {
                                    return goToThisPage(currentPage + 1);
                                } },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-light', 'aria-label': 'Next' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '>'
                                )
                            )
                        ),
                        currentPage !== props.pages && _react2.default.createElement(
                            'li',
                            { onClick: function onClick() {
                                    return goToThisPage(pages);
                                } },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-light', 'aria-label': 'Last' },
                                _react2.default.createElement(
                                    'span',
                                    { 'aria-hidden': 'true' },
                                    '\xBB'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

PaginationPanel.propTypes = {
    paginationSize: _propTypes2.default.number,
    currentPage: _propTypes2.default.number,
    pages: _propTypes2.default.number,
    goToThisPage: _propTypes2.default.func,
    props: _propTypes2.default.object
};


// WEBPACK FOOTER //
// ./src/Containers/StudentCustomContainer/Component/HSGStudentGrid/DataphiGrid.js